var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyOrganisation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.41,89.63c-5.02,0-9.11-4.27-9.11-9.53s4.09-9.53,9.11-9.53,9.11,4.27,9.11,9.53-4.09,9.53-9.11,9.53ZM14.41,72.58c-3.92,0-7.11,3.38-7.11,7.53s3.19,7.53,7.11,7.53,7.11-3.38,7.11-7.53-3.19-7.53-7.11-7.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.53,99.07H2.33c-.55,0-1-.45-1-1s.45-1,1-1h95.2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.28,98.75c-.55,0-1-.45-1-1V2.14h-49.58v31.58c0,.55-.45,1-1,1s-1-.45-1-1V1.14c0-.55.45-1,1-1h51.58c.55,0,1,.45,1,1v96.6c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.33,99.07H20.94c-.55,0-1-.45-1-1v-12.13c0-.55.45-1,1-1s1,.45,1,1v11.13h38.39v-57.09l-38.39-6.31v41.03c0,.55-.45,1-1,1s-1-.45-1-1v-42.21c0-.29.13-.57.35-.76.22-.19.52-.27.81-.22l40.39,6.64c.48.08.84.5.84.99v58.94c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.44,17.34h-33.9c-.55,0-1-.45-1-1s.45-1,1-1h33.9c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.44,27.7h-33.9c-.55,0-1-.45-1-1s.45-1,1-1h33.9c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.44,38.06h-14.46c-.55,0-1-.45-1-1s.45-1,1-1h14.46c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.44,48.42h-14.46c-.55,0-1-.45-1-1s.45-1,1-1h14.46c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.66,50h-10.6c-.55,0-1-.45-1-1s.45-1,1-1h10.6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.21,50h-10.6c-.55,0-1-.45-1-1s.45-1,1-1h10.6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.66,60.04h-10.6c-.55,0-1-.45-1-1s.45-1,1-1h10.6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.21,60.04h-10.6c-.55,0-1-.45-1-1s.45-1,1-1h10.6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.66,70.07h-10.6c-.55,0-1-.45-1-1s.45-1,1-1h10.6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.21,70.07h-10.6c-.55,0-1-.45-1-1s.45-1,1-1h10.6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.66,80.1h-10.6c-.55,0-1-.45-1-1s.45-1,1-1h10.6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.21,80.1h-10.6c-.55,0-1-.45-1-1s.45-1,1-1h10.6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.44,58.78h-14.46c-.55,0-1-.45-1-1s.45-1,1-1h14.46c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.44,69.13h-14.46c-.55,0-1-.45-1-1s.45-1,1-1h14.46c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.44,79.49h-14.46c-.55,0-1-.45-1-1s.45-1,1-1h14.46c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.41,99.07c-.55,0-1-.45-1-1v-12.79c0-.55.45-1,1-1s1,.45,1,1v12.79c0,.55-.45,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyOrganisation);
export default __webpack_public_path__ + "static/media/Company_Organisation.ab249261811335671365b469c42fd19b.svg";
export { ForwardRef as ReactComponent };